import GlobalStyle from "./styles/global";
import Routes from "../src/routes";

function App() {
  return (
    <>
      <GlobalStyle />
      <Routes />
    </>
  );
}

export default App;
